import { apiClient } from './client'
import type { Quote, QuoteCreate, QuoteWithDetails, PaginatedResponse } from '../types'

export const quotesApi = {
  getQuotes: async (page = 1, pageSize = 20, tagId?: number, sourceId?: number): Promise<PaginatedResponse<Quote>> => {
    const response = await apiClient.get('/quotes', {
      params: {
        page, page_size: pageSize,
        ...(tagId ? { tag_id: tagId } : {}),
        ...(sourceId ? { source_id: sourceId } : {}),
      },
    })
    return response.data
  },

  getQuote: async (id: number): Promise<QuoteWithDetails> => {
    const response = await apiClient.get(`/quotes/${id}`)
    return response.data
  },

  createQuote: async (quote: QuoteCreate): Promise<Quote> => {
    const response = await apiClient.post('/quotes', quote)
    return response.data
  },

  updateQuote: async (id: number, quote: Partial<QuoteCreate>): Promise<Quote> => {
    const response = await apiClient.put(`/quotes/${id}`, quote)
    return response.data
  },

  deleteQuote: async (id: number): Promise<void> => {
    await apiClient.delete(`/quotes/${id}`)
  },

  uploadImages: async (quoteId: number, files: File[]): Promise<void> => {
    const formData = new FormData()
    files.forEach((file) => {
      formData.append('files', file)
    })

    await apiClient.post(`/quotes/${quoteId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  searchQuotes: async (query: string): Promise<Quote[]> => {
    const response = await apiClient.get('/quotes/search', {
      params: { q: query },
    })
    return response.data
  },
}
